import { QuoteFormAttributesPatchRequestBody, QuoteFormRequestParams } from '@lio/api-types';
import { quoteFormQueryKeys } from '@services/quoteForm/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUpdateQuoteFormAttributes = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const result = useMutation({
    mutationKey: quoteFormQueryKeys.updateQuoteFormAttributesMutationKey,
    mutationFn: ({ quoteId, quoteForms }: QuoteFormAttributesPatchRequestBody & QuoteFormRequestParams) =>
      client
        .patch(`quote/${quoteId}/quote-form-attributes`, {
          json: {
            quoteForms,
          },
        })
        .json(),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['quote', { quoteId: variables.quoteId }],
      });
      queryClient.invalidateQueries({
        queryKey: quoteFormQueryKeys.searchWithParams({ quoteId: variables.quoteId }),
      });
    },
  });

  return { ...result, updateQuoteFormAttributes: result.mutate, updateQuoteFormAttributesAsync: result.mutateAsync };
};
